import 'reflect-metadata';
import { Service } from 'typedi';
import type { CardTypeStrategyData } from '../../types/card-strategy-data.type';
import type { SearchApiDocument } from '../../../../api/model/response/documents/SearchResult';
import { StrategyBuilder } from '../../StrategyBuilder';
import { CardStrategyService } from '../../CardStrategyService';

@Service({ id: 'myseCardStrategyService' })
export class MyseCardStrategyBuilder extends StrategyBuilder<CardStrategyService> {
  build(details: CardTypeStrategyData): CardStrategyService {
      return new MyseCardStrategyService(details);
  }
}

export class MyseCardStrategyService extends CardStrategyService {
  details;
  constructor(details: CardTypeStrategyData) {
      super();
      this.details = details;
  }

  productCardSources = [
    'ECAT_BSL',
    'ECAT_BSL_SUB',
    'CLIPSAL',
    'NAV_PES',
    'FAMILY_PES',
    'OFFER_PES',
    'PRD_SDLPAGE',
    'OFFER_PROMOTED',
    'ORACLE_CROSSREF',
  ];

  compareFeatureCountryCodes:string[] = [
    'nz','au'
  ];

  makeCard(doc: SearchApiDocument): string {
      if (this.details.cardType) {
        return this.details.cardType;
      }

      const isRedesignedCard = this.details?.params?.isSidePanelFeature || false;
      switch (true) {
      case isRedesignedCard:
        return 'uiaas-search-result-product-card-side-panel';
      case this.productCardSources.includes(doc.source):
        return 'uiaas-search-result-product-myse';
      case doc.source === 'VIDEO' && doc.f1Symbol !== 'Company':
        return 'uiaas-search-result-video-v2';
      case ['community_articles', 'community_forum'].includes(doc.source):
        return 'uiaas-search-result-community-support';
      case doc.source === 'BSL_DOC':
        return 'uiaas-search-result-document-v1';
      case doc.source === 'Order':
      case doc.source === 'Orders':
        return 'uiaas-search-result-order';
      case doc.source === 'Return':
      case doc.source === 'Returns':
        return 'uiaas-search-result-return';
      case doc.source === 'Delivery Notes':
      case doc.source === 'Delivery Note':
        return 'uiaas-search-result-delivery-note';
      case doc.source === 'Invoice':
      case doc.source === 'Invoices':
        return 'uiaas-search-result-invoice';
      case doc.source === 'SPA Contract':
      case doc.source === 'SPA Contracts':
        return 'uiaas-search-result-contract';
      case doc.source === 'QuotesCPQ':
        return 'uiaas-search-result-quote-cpq';
      case doc.source === 'Quotes':
        return 'uiaas-search-result-quote';
      case doc.source === 'DistributorStockLevel':
        return 'uiaas-search-result-stock-availability';
      case doc.source === 'CSOD_Training':
      case doc.source === 'Training':
        return 'uiaas-search-result-training';
      case doc.source === 'FAQ_BFO':
      case doc.source === 'FAQ_China':
        return 'uiaas-search-result-faq-v2';
      default:
        return 'uiaas-search-result-basic-v2';
      }
  }

  getCardProps(
    doc: SearchApiDocument,
    params: Record<string, string>
  ): Record<string, string> {
      if (this.details?.params) {
        if (this.compareFeatureCountryCodes.includes(this.details.params?.country ?? '')) {
          this.details.params.isCompareFeature = true;
        }
        return this.details.params;
      }
      return {};
  }
}
